import React from 'react';
import { Tabs } from 'antd';
import PromoCodeListingTab from './components/PromoCodes/PromoCodeListingTab';
import PromoTransactionsTab from './components/PromoTransactions/PromoTransactionsTab';

const { TabPane } = Tabs;

const PromoCodes = () => {
  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Promo Codes" key="1">
          <PromoCodeListingTab />
        </TabPane>
        <TabPane tab="Promo Transactions" key="2">
          <PromoTransactionsTab />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default PromoCodes;
